import {
    TenderContractsAllComponent,
    TenderContractsAwaitingBidsComponent,
    TenderContractsAwaitingReviewComponent
} from '../../../../../../pages';
import {
    TenderBidsResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractsAwaitingBidsResolver, TenderContractsAwaitingReviewResolver
} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const contractsAwaitingReviewRoute: Route = {
    path: 'awaiting-review',
    component: TenderContractsAwaitingReviewComponent,
    resolve: {
        contracts: TenderContractsAwaitingReviewResolver,
    },
};
